import DoGuide from './DoGuide';
import PaletteChoice from '../PaletteChoice';
import RowOfIcons from './RowOfIcons';
import ColorBar from '../PopUps/ColorBar';
import * as ActionModifiers from '../ActionModifiers';
import NormalBtn from '../StockItems/NormalBtn';

function App(props) {

  var currentList = props.currentList;
  var organicChanges = props.organicChanges;
  var addToExtraScreen = props.addToExtraScreen;
  var palette = props.palette;
  var changeTab = props.changeTab;
  var tabSelected = props.tabSelected;
  var modOptions = props.modOptions;
  var selectTab = tabSelected.s;

  var colorCombo = props.colorCombo;
  var setColorCombo = props.setColorCombo;
  var incrementCounter = props.incrementCounter;
  var customColorRecord = props.customColorRecord;
  var setCustomColorRecord = props.setCustomColorRecord;
  var isShowingCustom = props.isShowingCustom;
  var setIsShowingCustom = props.setIsShowingCustom;
  var counter = props.counter;
  var botHeight = props.botHeight;
  var chains = props.chains;

  var inside;
  var inside2;
  if (selectTab === 0){

    var cp = currentList.cp;

    function changeCP(loc, pp, alreadyGot){
      return function(e){
        if (alreadyGot){
          var changes = [{t:'r',w:['cp'],i:loc}];
          organicChanges(changes);
        }else{
          var out = {}
          pp.forEach((aPP, index)=>{
            out[index] = aPP.v;
          })
          var changes1 = [{t:'w',w:['cp', loc],n:out}];
          organicChanges(changes1);
        }
      }
    }

  //

    var cpKeys = Object.keys(cp);  
      var notSelectedP = palette.filter((aPalette, index)=>{
        return !cp[aPalette.v[0].v]
      })
    var loadPiece = <PaletteChoice palette1={notSelectedP} changeCP={changeCP} cp={cp} toHighlight={-1} />

  //
    var selectedText;
    var selectedTemplates;

    if (cpKeys.length > 0){
      selectedText = <p className="lead mb-0"  style={{padding:'10px'}}>Selected Palettes</p>
  //
      var selectedP = palette.filter((aPalette, index)=>{
        return cp[aPalette.v[0].v]
      })

      selectedTemplates = <PaletteChoice palette1={selectedP} changeCP={changeCP} cp={cp} toHighlight={-1} />

    }

    inside = <center>
      <DoGuide addToExtraScreen={addToExtraScreen} set={{t:'tabColors'}} />
    {selectedText}
    {selectedTemplates}
    <p className="lead mb-0" style={{padding:'10px'}}>Options</p>
    {loadPiece}
    </center>
  }else{
    if (modOptions.length === 0){
      inside = <p className='lead mb-0'>Nothing to modify. Tag elements you wish to modify via the Element tags under the Styles tab for each respective element</p>
    }else{
      inside = <ColorBar colorCombo={colorCombo} setColorCombo={setColorCombo} incrementCounter={incrementCounter}  customColorRecord={customColorRecord} setCustomColorRecord={setCustomColorRecord} isShowingCustom={isShowingCustom} setIsShowingCustom={setIsShowingCustom} modOptions={modOptions} palette={palette} counter={counter} height={botHeight}/>

      if (isShowingCustom || colorCombo){
        function changeTemplate(e){
          var components = ActionModifiers.getColorComponents(isShowingCustom, customColorRecord, palette, colorCombo);
          var currentListX = JSON.parse(JSON.stringify(currentList));
          var modOptions = ActionModifiers.findIssues(currentListX, components, 'amendNew', chains, changeTab);
          organicChanges(modOptions);
          setColorCombo(0);
          setIsShowingCustom(0);
        }

        inside2 = <div><NormalBtn backScreen={true} onClick={changeTemplate} title='Confirm Change'/><br/><br/></div>

      }
    }
  }

  var options = [{i:'bi:palette', n:'Palette'}, {i:'eva:color-picker-fill', n:'B'}];
  var icons = <RowOfIcons changeTab={changeTab} tabSelected={tabSelected} options={options}/>

  //      
  return (<div className='container' ><br/><center>
    {icons}<br/><br/>{inside2}
    {inside}</center></div>)
//
}

export default App;
